<template>
  <div>
    <PageMenu @listenToMenu="listenSwitch"/>
    <div class="container move" :class="{'to_left':isOpen}">
      <div class="scroll">
        <pageHead :open="isOpen"/>
        <div class="main_box">
          <el-breadcrumb class="current_location" separator="/">
            <transition-group name="breadcrumb" tag="p">
              <el-breadcrumb-item v-for="(item,index) in children" :key="item.path" v-if="children">
                  {{ languageId===1 ? item.meta.title :item.meta.enTitle}}
              </el-breadcrumb-item>
            </transition-group>
            <el-breadcrumb-item><i @click="comeback" v-if="$route.query.back" class="back">{{$t('common.back')}}</i></el-breadcrumb-item>
          </el-breadcrumb>
          <AppMain/>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import {AppMain, PageHead, PageMenu} from './components'
import {mixins} from "../utils/mixins";

export default {
  mixins:[mixins],
  data() {
    return {
      children: [],
      isOpen: false,
      isAlarm: false,
      isShow:false
    }
  },
  components: {
    AppMain,
    PageHead,
    PageMenu,
  },

  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      this.children = this.$route.matched;
    },

    listenSwitch(e) {
      this.isOpen = e;
    },

    comeback() {
      window.history.go(-1);
    },

  },
  watch: {
    "$route": function () {
      this.getBreadcrumb()
    }
  },
}
</script>

<style scoped>
.main_box {
  padding: 15px 20px;
}

.current_location{
  margin-bottom: 15px;
  position: relative;
}

.current_location p {
  text-align: left;
  font-weight: bold;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: #111;
}

.current_location .back{
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -7px;
  font-size: 14px;
  color: #427EF1;
  cursor: pointer;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue